module.exports = __webpack_public_path__ + "static/media/closeblue.3682513b.svg";